type Props = {
  className?: string;
};

/** Uniform AI affordance icon across Wave widgets and panels. */
export function WaveAiIcon({ className = "" }: Props) {
  return (
    <span
      className={`wave-ai-icon${className ? ` ${className}` : ""}`}
      aria-hidden
    >
      ✨
    </span>
  );
}
